import { render, staticRenderFns } from "./RelatorioRequisicoes.vue?vue&type=template&id=4e05e838&scoped=true&"
import script from "./RelatorioRequisicoes.vue?vue&type=script&lang=js&"
export * from "./RelatorioRequisicoes.vue?vue&type=script&lang=js&"
import style0 from "./RelatorioRequisicoes.vue?vue&type=style&index=0&id=4e05e838&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e05e838",
  null
  
)

export default component.exports